module.exports = __webpack_public_path__ + "static/media/image_red.bc04f9fb.png";